<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
    width="400px"
    class="cancel_booking_dialog"
    :title="$t('message.Booking.isCancelTip')"
  >
    <div class="booking_info">
      <div>
        {{ $t("message.Booking.cancelText", [bookingDate]) }}
      </div>
    </div>
    <div class="button_group">
      <GradientBtn type="primary" @click="$emit('close')">
        {{ $t("message.back") }}
      </GradientBtn>
      <el-button type="primary" @click="$emit('onCancelBooking')">
        {{ $t("message.Booking.confirmCancel") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import GradientBtn from "../../../components/GradientBtn";
import { getWeek } from "@/util/util";

export default {
  components: { GradientBtn },
  props: {
    visible: Boolean,
    value: Object,
  },
  data() {
    return {};
  },
  computed: {
    bookingDate() {
      const { details } = this.value || {};
      if (!this.value?.details || !this.value?.details[0] || !this.value?.details[0].applicationDate) return "";
      return `${this.$formatDate(
        this.value?.details[0].applicationDate,
        "dd/MM/yyyy"
      )}（${getWeek(details[0].applicationDate)}）`;
    },
  },
};
</script>

<style lang="scss" scoped>
.cancel_booking_dialog {
  padding: 10px 0;
  font-size: 16px;
  /deep/.el-dialog__body {
    padding: 16px;
  }
  /deep/.el-dialog {
    border-radius: 8px;
  }
  /deep/.el-dialog__header {
    padding: 16px 16px 0;
    .el-dialog__title {
      font-size: 20px;
    }
  }
  .button_group {
    text-align: center;
    display: flex;
    justify-content: space-between;
    gap: 8px;
    .el-button {
      width: 100%;
      font-size: 18px;
    }
    .el-button:nth-child(1) {
      max-width: 40%;
    }
    .el-button:nth-child(2) {
      max-width: 60%;
    }
  }
  .booking_info {
    font-size: 16px;
    margin-bottom: 16px;
    > div {
      margin: 5px 0;
    }
    .booking_date {
      color: #4dbab0;
    }
  }
  .el-button + .el-button {
    margin-left: 0;
  }
}

@media screen and (max-width: 500px) {
  .cancel_booking_dialog {
    .button_group {
      flex-wrap: wrap;
      .el-button:nth-child(1) {
        max-width: 100% !important;
      }
      .el-button:nth-child(2) {
        max-width: 100% !important;
      }
    }
  }
}
</style>
